import Swal, { type SweetAlertResult } from "sweetalert2";



import { i18n } from "@/portal/Trans";
import { TastierGlobal } from "@/portal/globalAccess";
import { SessionExpiredModal } from "@/portal/modal/SessionExpiredModal";


export class UiNotification {
    private static dialog: any;

    public static showSuccess(message: string, delay?: number) {
        $["notify"](
            {
                message: message,
            },
            {
                type: "info",
                allow_dismiss: false,
                newest_on_top: true,
                animate: {
                    enter: "animated fadeInDown",
                    exit: "animated fadeOutUp",
                },
                placement: {
                    from: "top",
                    align: "right",
                },
                offset: {
                    y: 30,
                    x: 10,
                },
                delay: delay === undefined ? 2400 : delay,
                timer: 400,
            }
        );
    }

    public static showSuccessAlert(message: string, title?: string) {
        Swal.fire({
            title: title === undefined ? "" : title,
            text: message,
            confirmButtonColor: "#89b841",
            icon: "success",
        });
    }

    public static showException(exception: string, title?: string, confirmed?: { () }) {
        Swal.fire({
            title: title === undefined ? i18n("general.failed") : title,
            text: exception,
            confirmButtonColor: "#89b841",
            icon: "error",
        }).then((result: SweetAlertResult) => {
            if (result.value === true && confirmed) {
                confirmed();
                return;
            }
        });
    }

    public static showWarning(exception: string, title?: string, confirmed?: { () }) {
        Swal.fire({
            title: title === undefined ? i18n("enums.LogLevel.Warning") : title,
            text: exception,
            confirmButtonColor: "#89b841",
            icon: "warning",
        }).then((result: SweetAlertResult) => {
            if (result.value === true && confirmed) {
                confirmed();
                return;
            }
        });
    }

    public static confirm(
        message: string,
        title?: string,
        confirmed?: { () },
        confirmBtn?: string,
        cancelled?: { () },
        cancelBtn?: string,
        confirmButtonClass?: string,
        cancelButtonClass?: string,
        containerCustomeClass?: string,
        dismissed?: { () }
    ) {
        Swal.fire({
            title: title,
            text: message,
            showCancelButton: true,
            cancelButtonText: cancelBtn === undefined ? i18n("general.cancel") : cancelBtn,
            reverseButtons: true,
            confirmButtonText: confirmBtn === undefined ? i18n("general.remove") + "!" : confirmBtn,
            customClass: {
                confirmButton: confirmButtonClass ?? "btn btn-success",
                cancelButton: cancelButtonClass ?? "btn btn-secondary",
                container: containerCustomeClass,
            },
            buttonsStyling: false,
        }).then((e: SweetAlertResult) => {
            if (e.value === true && confirmed) {
                confirmed();
                return;
            }

            if (e.dismiss == Swal.DismissReason.cancel && cancelled) {
                cancelled();
                return;
            }

            if (e.dismiss != null && dismissed) {
                dismissed();
            }
        });
    }

    public static confirmWithOptions(options: {
        message: string;
        title?: string;
        confirmed?: () => void;
        confirmBtn?: string;
        cancelled?: () => void;
        cancelBtn?: string;
        confirmButtonClass?: string;
        cancelButtonClass?: string;
        containerCustomeClass?: string;
        dismissed?: () => void;
    }) {
        this.confirm(
            options.message,
            options.title,
            options.confirmed,
            options.confirmBtn,
            options.cancelled,
            options.cancelBtn,
            options.confirmButtonClass,
            options.cancelButtonClass,
            options.containerCustomeClass,
            options.dismissed
        );
    }

    // same confirmation, with a single select the user has to answer before confirming.
    // the selected option key is handed to the callback instead of a bare confirmation
    public static confirmWithSelect(options: {
        message: string;
        title?: string;
        selectOptions: Record<string, string>;
        selectedValue: string;
        confirmed: (value: string) => void;
        confirmBtn?: string;
        cancelBtn?: string;
    }) {
        Swal.fire({
            title: options.title,
            text: options.message,
            input: "select",
            inputOptions: options.selectOptions,
            inputValue: options.selectedValue,
            showCancelButton: true,
            cancelButtonText: options.cancelBtn === undefined ? i18n("general.cancel") : options.cancelBtn,
            reverseButtons: true,
            confirmButtonText: options.confirmBtn === undefined ? i18n("general.remove") + "!" : options.confirmBtn,
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-secondary",
            },
            buttonsStyling: false,
        }).then((e: SweetAlertResult) => {
            if (e.isConfirmed) options.confirmed(e.value);
        });
    }

    public static setLoading(isLoading: boolean) {
        if (UiNotification.dialog === undefined) {
            UiNotification.dialog = TastierGlobal.getKTDialog({
                placement: "top center",
                type: "loader",
                width: 120,
                state: "default",
                message: i18n("general.loading"),
            });

            if (isLoading) UiNotification.dialog.show();
        }

        if (isLoading && UiNotification.dialog.hidden()) UiNotification.dialog.show();
        else if (!isLoading && UiNotification.dialog.shown()) UiNotification.dialog.hide();
    }

    public static showSessionExpired() {
        new SessionExpiredModal().show();
    }
}
